import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TESTIMONIALS_CAPGO } from '@app/config/testimonials';
import { JsonLdService, MetaService } from '@app/core';
import {
  CtaSectionComponent,
  CustomerLogoSectionComponent,
  SectionHeaderComponent,
  TestimonialsSectionComponent,
} from '@app/widgets';
import { COMPARE_CAPGO_FAQS } from '../../constants';
import { CompareCapgoAdvantagesSectionComponent } from '../compare-capgo-advantages-section/compare-capgo-advantages-section.component';
import { CompareCapgoFaqSectionComponent } from '../compare-capgo-faq-section/compare-capgo-faq-section.component';
import { CompareCapgoHeroSectionComponent } from '../compare-capgo-hero-section/compare-capgo-hero-section.component';
import { CompareCapgoTableSectionComponent } from '../compare-capgo-table-section/compare-capgo-table-section.component';

@Component({
  selector: 'app-compare-capgo',
  imports: [
    CompareCapgoHeroSectionComponent,
    CustomerLogoSectionComponent,
    CompareCapgoAdvantagesSectionComponent,
    CompareCapgoTableSectionComponent,
    SectionHeaderComponent,
    TestimonialsSectionComponent,
    CompareCapgoFaqSectionComponent,
    CtaSectionComponent,
  ],
  templateUrl: './compare-capgo.component.html',
  styleUrl: './compare-capgo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareCapgoComponent {
  protected readonly testimonials = TESTIMONIALS_CAPGO;

  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setTitle('The #1 Alternative to Capgo: Capawesome Cloud');
    this.metaService.setKeywords([
      'Capgo alternative',
      'Capacitor live updates',
      'OTA updates',
    ]);
    this.metaService.setDescription(
      'Compare Capawesome Cloud with Capgo. Complete mobile CI/CD solution with production-ready Native Builds, automated App Store Publishing, and reliable Live Updates — all in one platform with expert support.',
    );
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Capawesome Cloud vs Capgo',
        'Compare Capawesome Cloud with Capgo for live updates and mobile CI/CD.',
        'https://cloud.capawesome.io/compare/capgo/',
      ),
      JsonLdService.buildFaqSchema(COMPARE_CAPGO_FAQS),
    ]);
  }
}
